
import React, { useEffect, useRef } from "react";


function MapUI({
    center,
    zoom,
    children,
    setMap
}: {
    center: google.maps.LatLngLiteral;
    zoom: number;
    children: JSX.Element | React.ReactNode[];
    setMap: (map: google.maps.Map) => void;
}) {

    const ref = useRef<HTMLDivElement>(null);
    const [map, setInnMap] = React.useState<google.maps.Map>();

    useEffect(() => {

        if (ref.current && !map) {
            const mapins = new window.google.maps.Map(ref.current, {
                center, zoom,
                streetViewControl: true,
                mapTypeControlOptions: {
                    mapTypeIds: [google.maps.MapTypeId.ROADMAP]
                },
                mapTypeControl: false,
                zoomControl: false,
                fullscreenControl: false
            })

            setInnMap(mapins)
            setMap(mapins)

        }

    }, [ref, map]);

    return (
        <div className='shadow'
            style={{ position: 'relative', height: "100%", width: "100%", borderRadius: "10px", border: "solid 4px #fff" }}>
            <div ref={ref} id="map" style={{ height: "100%", width: "100%" }} />
            {
                React.Children.map(children, (child) => {
                    if (React.isValidElement(child)) {
                        // @ts-ignore
                        return React.cloneElement(child, { map });
                    }
                })
            }
        </div>
    )

}


export default MapUI 